import React from 'react';
import { useTheme } from '../../theme/ThemeContext';

const EmptyState = ({ icon: Icon, text }) => {
  const theme = useTheme();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px 16px', gap: 12 }}>
      <Icon s={40} c={theme.textM} sw={1.5} />
      <span style={{ fontSize: 13, color: theme.textM, fontWeight: 500 }}>{text}</span>
    </div>
  );
};

export default EmptyState;
